const activeTabClass = 'personnel-grid__tab-active';
const activeCatClass = 'personnel-grid__cat-active';
const tabs = $('.personnel-grid__tab');
const cats = $('.personnel-grid__cat');
const personnel = $('.personnel-card');
const quote = $('.graduates-quote');
let offsetPage = 0;
let totalPosts = $('.personnel-grid__employees').attr('total-posts');
let currentPage = 1;

let catData = $('.personnel-grid__employees').attr('cat-data');
const ajaxUrl = document.location.origin + '/wp/wp-admin/admin-ajax.php';
const employeeGrid = $('.personnel-grid__employees-wrap');

if ($('.personnel-grid').length) {
    disablePrev();

    if (totalPosts < 7 || $('.personnel-grid__employees')[0]) {
        $('.pagination').hide();
    }

    $('.pagination__next').show();
    if (6 >= totalPosts) {
        $('.pagination').hide();
    } else {
        $('.pagination').show();
    }
    let firstGrid = $('.personnel-grid__tab-active').attr('filter');

    cats.each(function() {
        if ($(this).attr('data') === firstGrid) {
            $(this).addClass(activeCatClass);
        }
    });

    tabs.on('click', function() {
        tabs.removeClass(activeTabClass);
        $(this).addClass(activeTabClass);
        cats.removeClass(activeCatClass);

        resetCount();
        disablePrev();

        if ($(this).hasClass('personnel-grid__tab-development')) {
            $('.agile-filter').hide();
            $('.development-filter').show();
            $(this).addClass(activeTabClass);
        } else if ($(this).hasClass('personnel-grid__tab-agile')) {
            $('.development-filter').hide();
            $('.agile-filter').show();
            $(this).addClass(activeTabClass);
        } else if ($(this).hasClass('personnel-grid__tab-management')) {
            $('.agile-filter').hide();
            $('.development-filter').hide();
        } else if ($(this).hasClass('development-tab')) {
            $('.personnel-grid__tab-development').addClass(activeTabClass);
        } else if ($(this).hasClass('agile-tab')) {
            $('.personnel-grid__tab-agile').addClass(activeTabClass);
        }

        catData = $(this).attr('filter');

        if ($(this).hasClass('employees-btn')) {
            ajaxCall('load_employees', false);
        } else {
            ajaxCall('load_graduates', true);
        }

        function ajaxCall(load, graduates) {
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: {
                    action: load,
                    slug: catData,
                    offset: 0,
                },
                beforeSend: function() {
                    $('body').addClass('loading');
                    employeeGrid.css('opacity', '0.5');
                },
                success: function(data) {
                    $('body').removeClass('loading');
                    employeeGrid.html(data).css('opacity', '1');
                    totalPosts = $('.personnel-grid__employees').attr('total-posts');

                    paginationTotal();

                    if (6 >= totalPosts) {
                        $('.pagination').hide();
                    } else {
                        $('.pagination').show();
                    }

                    if (graduates === true) {
                        loadQuotes();
                    }
                },
                error: function(textStatus, errorThrown) {
                    console.error('AJAX Error: ', textStatus, errorThrown);
                },
            });
        }
    });

    $('.pagination__next').on('click', function() {
        offsetPage += 6;
        currentPage++;

        if (offsetPage + 6 >= totalPosts) {
            $('.pagination__next')
                .addClass('disabled')
                .css('opacity', '0');
        } else {
            $('.pagination__next')
                .removeClass('disabled')
                .css('opacity', '1');
        }

        disablePrev();

        if (
            $(this)
                .parent()
                .hasClass('pagination__type-employees')
        ) {
            ajaxCallPagination('load_employees', offsetPage, catData);
        } else {
            ajaxCallPagination('load_graduates', offsetPage, catData);
        }

        $('html, body').animate(
            {
                scrollTop: $('.personnel-grid__employees').offset().top - 180,
            },
            1000
        );
    });

    $('.pagination__prev').on('click', function() {
        offsetPage -= 6;
        currentPage--;

        disablePrev();

        if (offsetPage < 0) {
            offsetPage = 0;
        }

        $('.pagination__next').show();

        if (
            $(this)
                .parent()
                .hasClass('pagination__type-employees')
        ) {
            ajaxCallPagination('load_employees', offsetPage, catData);
        } else {
            ajaxCallPagination('load_graduates', offsetPage, catData);
        }

        $('html, body').animate(
            {
                scrollTop: $('.personnel-grid__employees').offset().top - 180,
            },
            1000
        );
    });

    function ajaxCallPagination(load, offsetPage, catData) {
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: load,
                slug: catData,
                offset: parseInt(offsetPage),
            },
            beforeSend: function() {
                $('body').addClass('loading');
                employeeGrid.css('opacity', '0.5');
            },
            success: function(data) {
                $('body').removeClass('loading');
                employeeGrid.html(data).css('opacity', '1');
                paginationTotal();
            },
            error: function(textStatus, errorThrown) {
                console.error('AJAX Error: ', textStatus, errorThrown);
            },
        });
    }

    function disablePrev() {
        if (offsetPage <= 0) {
            $('.pagination__prev')
                .addClass('disabled')
                .css('opacity', '0');
            currentPage = 1;
        } else {
            $('.pagination__prev')
                .removeClass('disabled')
                .css('opacity', '1');
        }

        if (currentPage === 1) {
            $('.pagination__prev')
                .addClass('disabled')
                .css('opacity', '0');

            $('.pagination__next')
                .removeClass('disabled')
                .css('opacity', '1');
        }

        $('.pagination__current').text(currentPage);
    }

    function resetCount() {
        offsetPage = 0;
        currentPage = 1;
    }

    paginationTotal();

    function paginationTotal() {
        let paginationTotal = 0;
        paginationTotal = totalPosts / 6;
        $('.pagination_total').text(Math.ceil(paginationTotal));
    }
}

loadQuotes();

function loadQuotes() {
    if ($('.personnel-grid__graduates-quote')[0]) {
        const personnel = $('.personnel-card');
        const quote = $('.graduates-quote');

        $(personnel).on('click', function() {
            let postId = $(this).attr('post-id');

            $('html, body').animate(
                {
                    scrollTop: $('.personnel-grid__graduates-quote').offset().top - 180,
                },
                1000
            );

            $('body,html').on('bind', 'scroll mousedown wheel DOMMouseScroll mousewheel keyup', function(e) {
                if (e.which > 0 || e.type == 'mousedown' || e.type == 'mousewheel') {
                    $('html,body').stop();
                }
            });

            $(personnel).removeClass('personnel-card__active');
            $(this).addClass('personnel-card__active');
            $('.personnel-grid__graduates-quote').addClass('personnel-grid__graduates-quote-active');

            $(quote).hide();

            $(`.graduates-quote[post-id="${postId}"]`).css('display', 'flex');
        });
    }
}
